import React from "react";

import { t } from "app/utils";

import sentiment1 from "images/sentiment/1.svg";
import sentiment2 from "images/sentiment/2.svg";
import sentiment3 from "images/sentiment/3.svg";
import sentiment4 from "images/sentiment/4.svg";
import sentiment5 from "images/sentiment/5.svg";

const sentiments = {
  1: sentiment1,
  2: sentiment2,
  3: sentiment3,
  4: sentiment4,
  5: sentiment5
};

type SentimentProps = {
  sentiment: 1 | 2 | 3 | 4 | 5;
};

const Sentiment: React.FC<SentimentProps> = ({ sentiment }) => (
  <img
    className="w-30px"
    src={sentiments[sentiment]}
    alt={t("Sentiment")}
  />
);

export default Sentiment;
